const ort01 = require("../assets/images/mix&match/ort01.jpg").default;
const ort02 = require("../assets/images/mix&match/ort02.jpg").default;

export const mixMatchs = [
  {
    imgs: [ort01, ort02],
    productIds: ["Q01", "A03"],
  },
];
